import { render, staticRenderFns } from "./FindOrCreateProductItem.vue?vue&type=template&id=386b137e&"
import script from "./FindOrCreateProductItem.vue?vue&type=script&lang=js&"
export * from "./FindOrCreateProductItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports